import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Grid, Select, MenuItem, Modal } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorAlert, successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';
import useFetchData from 'hooks/useFetchData';
import { deepPurple } from '@mui/material/colors';

// TODO: The component name as well as the file name should be changed.
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const NewUpdatePayoutRequestModal = ({ row, fetchPayouts, payoutRequestStatus }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);

    const [loading, setLoading] = useState(false);

    const doSomething = async () => {
        //TODO: do something
        setOpen(false);
    };
    const handleClose = () => setOpen(false);

    const [updateAmount, setUpdateAmount] = useState(row.amount);
    const [updateStatus, setUpdateStatus] = useState(row.statusID);
    const [updateStatusName, setUpdateStatusName] = useState('');

    const handleStatusChange = (e) => {
        setUpdateStatus(e.target.value);
        setUpdateStatusName(e.target.name);
    };

    const updatePayoutRequest = async (row) => {
        try {
            const res = await axiosInstance.put(
                `/PayoutRequest`,
                {
                    id: parseInt(row.id),
                    statusID: parseInt(updateStatus),
                    thirdPartyID: parseInt(row.thirdPartyID),
                    processingFees: parseFloat(row.processingFees),
                    amount: parseFloat(updateAmount)
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Update Successfully.');
                fetchPayouts();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
        finally{
            setLoading(false);
        }
    };

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)} fullWidth>
                Update Record
            </Button>
            <Modal open={open} onclose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingY: '20px'
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Payout Request
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Amount :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateAmount}
                                            onChange={(e) => setUpdateAmount(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            <span style={{ color: 'red' }}>*</span>Status :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateStatus}
                                            onChange={handleStatusChange}
                                            // sx={{width:"100%"}}  
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="">
                                                Select Status
                                            </MenuItem>
                                            {payoutRequestStatus.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => updatePayoutRequest(row)}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default NewUpdatePayoutRequestModal;
